import {
	CancelButton,
	Container,
	DeleteButton,
	Exclamation,
	Header,
	StyledGrid,
	StyledText,
} from './DeleteUserForm.styles';

import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';

export interface Props {
	deleteUser: () => void;
	cancel: () => void;
	username: string;
}

export default function DeleteUserForm(props: Props) {
	const { t } = useGlobalization();
	return (
		<Container>
			<Exclamation>&#33;</Exclamation>
			<Header>
				{t('Delete User')} ({props.username})?
			</Header>
			<StyledText>
				{t('Do you really want to delete {{user}}?', {
					user: props.username,
				})}
				<br />
				{t('This action cannot be undone.')}
			</StyledText>
			<StyledGrid>
				<DeleteButton
					data-cy="deleteButton"
					variant={'contained'}
					onClick={() => props.deleteUser()}>
					{t('DELETE')}
				</DeleteButton>
				<CancelButton
					data-cy="cancelButtonModal"
					variant={'contained'}
					onClick={() => props.cancel()}>
					{t('Cancel')}
				</CancelButton>
			</StyledGrid>
		</Container>
	);
}
